import type { FaireProductEntity } from "../../entity_types/product";

export const p_upx548rnan: FaireProductEntity = {
  token: "p_upx548rnan",
  type: "product",
  name: "Blossom 3/4 Sleeve Boxy Knit Button Down Sweater Cardigan",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/ab1e08f85e5c59e5aa86534d30cf3c386f2e3aa578fa62f97786b1ad42934795.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2eb1d6fdf5cbae08d0b704334c21b0ca435d86454af99cf0f4e2927f1deb68d.jpeg",
    "https://cdn.faire.com/fastly/be3ce9f14f529d00da3451f8e3ce27fab8e7e439c24e179cea7ccab998546042.jpeg",
    "https://cdn.faire.com/fastly/2fd5971291a8f6bafdaac15aacc55044201c8fbd62fac6c31c975f56d62b38d6.jpeg",
    "https://cdn.faire.com/fastly/6be82e2e299a7167592dd613a55e3e892284d43dd3e5a412e6123a6f133a075a.jpeg",
    "https://cdn.faire.com/fastly/0eac00ca9c6cabee0515efb0fe5a309fdc30cb28f874aba149698059822b952d.jpeg",
    "https://cdn.faire.com/fastly/86a99f24251d19a1c40dff8299b310be63d73e0f2e183fc01e4fb6b092f9287f.jpeg",
    "https://cdn.faire.com/fastly/cb38fa98e4f8f32c4711b4010004c4df4fd780b1428b28920287481bf8396927.jpeg",
    "https://cdn.faire.com/fastly/4d4a2d9c0580c3e8cf0b22ab48b6e14fd8e30d9cd8cca671548b9c83abac85d1.jpeg",
    "https://cdn.faire.com/fastly/a4cbf813865b477b839ce725b02f0b0e914218cfa8f7b5286df37aa0e03ebee9.jpeg",
    "https://cdn.faire.com/fastly/df5535625b77286d9a5a56e640bc3d19ffa4aa5380d5cdfddcd39d52bbf64221.jpeg",
    "https://cdn.faire.com/fastly/6e6ed7874999b5038dab947241f4002c089c2c2f284bf07699e1748ac08a321e.jpeg",
    "https://cdn.faire.com/fastly/55f4538bd2c0667ba6c2a65905938eee55b4db6cb0d3711d48836a3925d8fd10.png",
  ],
  priceDollars: 100,
  description:
    "Boxy knit cardigan offers a relaxed, modern layering silhouette.\n3/4 sleeve design is perfect for transitional seasons.\nButton down cardigan provides easy wear with classic styling.\nSoft knit sweater cardigan pairs effortlessly with jeans or dresses.\n\nBrand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_kzks8vegvk",
  tags: [],
  msrpDollars: 200,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:24.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
